import * as React from 'react'
// libs
import { FieldArray, InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
// components
import Rules from './components/Rules'
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// views
import { Form, ButtonsWrapper } from './views'
// types
import { IOption } from 'components/FormElements/Select'

export type FilterRulesFormData = {
  rules: {
    action: IOption
    property: IOption
    businessUnit: IOption
  }[]
}

interface Props {
  onCancel: () => void
}

const FilterRulesForm: React.FC<Props & InjectedFormProps<FilterRulesFormData, Props>> = ({
  onCancel,
  submitting,
  handleSubmit
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Scrollbar>
        <FieldArray<any> name='rules' component={Rules} />
      </Scrollbar>
      <ButtonsWrapper>
        <Button disabled={submitting} shadowLess type='submit' layout={BUTTON_LAYOUTS.PURPLE}>
          Save
        </Button>
        <Button
          shadowLess
          type='button'
          onClick={onCancel}
          disabled={submitting}
          layout={BUTTON_LAYOUTS.PURPLE_INVERTED}>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Form>
  )
}

export default reduxForm<FilterRulesFormData, Props>({
  form: Forms.LOOKUP_FILTER_FORM,
  enableReinitialize: true,
  destroyOnUnmount: true
})(FilterRulesForm)
